export default "__VITE_ASSET__7IDv48dq__"